<script lang="ts">
    import { initCkEditorEmbeds } from './initCkEditorEmbeds';

    /** Renders sanitized admin HTML with shared CKEditor content styles. */
    export let html: string = '';
    export let className = '';
    export let testId: string | undefined = undefined;
</script>

<div
    class="ck-content max-w-none leading-relaxed {className}"
    data-testid={testId}
    use:initCkEditorEmbeds
>
    {@html html}
</div>

<style>
    .ck-content :global(iframe) {
        max-width: 100%;
        height: auto;
        aspect-ratio: 16 / 9;
    }

    .ck-content :global(.twitter-tweet) {
        margin: 1em auto !important;
    }
</style>
